import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../api/services/auth.service';

@Injectable()
export class AdminGuardService implements CanActivate {

    constructor(private auth: AuthService, private router: Router) { }

    hasAccess() {
      const roles = this.auth.getRoles();
      return ['ADMIN', 'LIST_CLIENTS', 'CREATE_CLIENT', 'LIST_USERS', 'CREATE_USER']
        .filter(n => roles.indexOf(n) !== -1)
        .length > 0
      ;
    }

    canActivate(route, state: RouterStateSnapshot): boolean {
      if (!this.hasAccess()) {
          this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
          return false;
      }
      return true;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/admin-guard.service.ts